import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { commonReducerMap } from '@labrav/common'

import { marketplaceReducerMap } from './reducer'

export {
  useDispatch,
  useSelector,
  useAppDispatch,
  useAppSelector,
} from './hooks'
export type { RootState, AppDispatch } from './types'
export {
  marketplaceReducerMap,
  rootReducer,
  type MarketplaceRootState,
} from './reducer'

const testRootReducer = combineReducers({
  ...commonReducerMap,
  ...marketplaceReducerMap,
})

export const getStore = () =>
  configureStore({
    reducer: testRootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: true,
        immutableCheck: false,
        serializableCheck: false,
      }),
  })
